import { render, staticRenderFns } from "./AddSpecialMakeupClassModal.vue?vue&type=template&id=71429d35&scoped=true&"
import script from "./AddSpecialMakeupClassModal.vue?vue&type=script&lang=js&"
export * from "./AddSpecialMakeupClassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71429d35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71429d35')) {
      api.createRecord('71429d35', component.options)
    } else {
      api.reload('71429d35', component.options)
    }
    module.hot.accept("./AddSpecialMakeupClassModal.vue?vue&type=template&id=71429d35&scoped=true&", function () {
      api.rerender('71429d35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/credits/components/AddSpecialMakeupClassModal.vue"
export default component.exports